import React from "react";
import pageNotFound from "../assets/images/404.png";
import "./404.css";

const Notfound = () => {
  return (
    <div id="container-404">
      <img src={pageNotFound} alt="404" />
      <span>Oops, Page Not Found. </span>
    </div>
  );
};

export default Notfound;
